module.exports = __webpack_public_path__ + "static/media/116.c4943b8b.svg";